export const SMS_PAST_DUE = "smsForPastDue";
export const OPT_GENERAL = "optInGeneral";
export const OPT_EMERGENCY = "optInEmergency";
export const DISPLAY_NAME = "displayName";
export const PROP_ADDRESS = "displayPropAddress";
export const DISPLAY_EMAIL = "displayEmailAddress";
export const DISPLAY_MOBILE = "displayMobile";
export const DISPLAY_LANDLINE = "displayLandline";
export const ADS = "optInPartnerOnlineAds";
export const PARTNER_EMAIL = "optInPartnerEmails";
export const PREFERENCE_ID = "preferenceId";


export const PROPERTY_ID = "propertyId";
export const NEIGHBOR_PROPERTY_ID = "neighborPropertyIds";
export const CONSENT_ENABLED = "consentEnabled";